import decode from 'decode-uri-component';

/**
 * Manager to work with cookies context on client side
 */
export class CookiesManager {
    /**
     * Returns cookie value by passed name as the key
     * @param {string} name - cookie name
     * @returns {string} cookie value
     */
    get(name) {
        const cookies = this.getAll();

        return cookies[name];
    }

    /**
     * Returns all cookies
     * @returns {object} cookies
     */
    // eslint-disable-next-line class-methods-use-this,require-jsdoc
    getAll() {
        const pairs = document.cookie.split(';');
        const cookies = {};

        for (let i = 0; i < pairs.length; i++) {
            const pair = pairs[i].split('=');

            if (pair[0] && pair[1]) {
                cookies[`${pair[0]}`.trim()] = decode(pair[1]);
            }
        }

        return cookies;
    }
}
